import {
	rekeningBank,
	rekeningBankDetail,
	akunKeuangan,
	pagination,
	paginationRiwayatTransfer,
	riwayatTransfer,
	riwayatTransferDetail,
	search
} from "./state"

const mutations = {
	setRekeningBank: (state, res) => {
		if (state.rekeningBank.data !== undefined) {
			state.rekeningBank.data.data_array = [...state.rekeningBank.data.data_array, ...res.data.data_array];
		} else {
			state.rekeningBank = res
		}
	},
	setRiwayatTransfer: (state, res) => {
		if (state.riwayatTransfer.data !== undefined) {
			if (res.data.data_array !== null) {
				state.riwayatTransfer.data.data_array = [...state.riwayatTransfer.data.data_array, ...res.data.data_array];
			}
		} else {
			state.riwayatTransfer = res
		}
	},
	setRekeningBankDetail: (state, res) => {
		state.rekeningBankDetail = res.data
	},
	setRekeningAtasNama: (state, res) => {
		state.rekeningAtasNama = res.data.data
	},
	setAkunKeuangan: (state, res) => {
		state.akunKeuangan = res.data.data
	},
	resetRekeningBank: (state) => {
		state.rekeningBank = rekeningBank()
	},
	resetRiwayatTransfer: (state) => {
		state.riwayatTransfer = riwayatTransfer()
	},
	resetRekeningBankDetail: (state) => {
		state.rekeningBankDetail = rekeningBankDetail()
	},
	setRiwayatTransferDetail: (state, res) => {
		state.riwayatTransferDetail = res.data
	},
	resetRiwayatTransferDetail: (state) => {
		state.riwayatTransferDetail = riwayatTransferDetail()
	},

	// search
	setSearch: (state, search) => {
		state.search.key = search;
	},
	resetSearch: (state) => {
		state.search = search();
	},
	setIsSearch: (state, bool) => {
		state.isSearch = bool
	},

	// search riwayat transfer
	setSearchRiwayatTransfer: (state, search) => {
		state.searchRiwayatTransfer.key = search;
	},
	resetSearchRiwayatTransfer: (state) => {
		state.searchRiwayatTransfer = search();
	},
	setIsSearchRiwayatTransfer: (state, bool) => {
		state.isSearchRiwayatTransfer = bool
	},

	// pagination
	setNextPagination: (state, payload) => {
		state.pagination.length = payload.data.data_array.length
		state.pagination.pageNumber++
		state.pagination.offset = state.pagination.pageNumber * state.pagination.limit
	},
	setNextPaginationRiwayatTransfer: (state, payload) => {
		state.paginationRiwayatTransfer.length = payload.data.data_array.length
		state.paginationRiwayatTransfer.pageNumber++
		state.paginationRiwayatTransfer.offset = state.paginationRiwayatTransfer.pageNumber * state.paginationRiwayatTransfer.limit
	},
	resetPagination: (state, e) => {
		state.pagination = pagination()
	},
	resetPaginationRiwayatTransfer: (state, e) => {
		state.paginationRiwayatTransfer = paginationRiwayatTransfer()
	},

	setScrollPosition: (state, positionY) => {
		state.scrollPosition = positionY - 100
	},
	setScrollPositionRiwayatTransfer: (state, positionY) => {
		state.scrollPositionRiwayatTransfer = positionY - 120
	}
}

export default mutations